module.exports = __webpack_public_path__ + "static/media/threads_logo.210aeddb.svg";